import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class PermitTypesLookupModel extends ModelBase<PermitTypesLookupModel, any> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = PermitTypesLookupModel.DEFAULT_ID;

    @observable
    public displayName: string = PermitTypesLookupModel.DEFAULT_DISPLAYNAME;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = PermitTypesLookupModel.DEFAULT_ID;
        this.displayName = PermitTypesLookupModel.DEFAULT_DISPLAYNAME;
    }

    @action
    public fromDto(dto: PermitTypesDTO): void {
        this.id = dto.id;
        this.displayName = dto.displayName;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: PermitTypesDTO[]): PermitTypesLookupModel[] {
        const types: PermitTypesLookupModel[] = [];

        for (const dto of dtos) {
            const model = new PermitTypesLookupModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface PermitTypesDTO {
    id: string;
    displayName: string;
}
